import { useEffect, useState } from "react";
import {
  useNavigate,
  useLocation,
  Link,
  useSearchParams,
} from "react-router-dom";
import Sidebar from "../components/SidebarUpdate";

import Category from "../components/Category";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../components/Breadcrumb";
import apiInstance from "../apiConfig/apiinstance";
import DummyImage from "../assest/images/dummy_image.jpg";
import Pagination from "../components/Pagination";
import { useParams } from "react-router-dom";
const Sidebarstags = () => {
  const { id } = useParams();
  console.log(id);
  const navigate = useNavigate();
  const location = useLocation();
  const [subCategory, setSubcategory] = useState([]);
  const [categoryImages, setCatagoryImages] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  // const [paginatedCategoryImages, setPaginatedCategoryImages] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [error, setError] = useState(null);
  const [categoryLoading, setSubCategoryLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 100;

  const currentCategory = location.pathname.split("/")[2];

  console.log("current category in tags", currentCategory);

  //   const fetchSubCategoryData = async (lastCategory) => {
  //     setSubCategoryLoading(true);
  //     setError(null);
  //     try {
  //       const { data } = await axios.get(
  //         `${BaseUrl()}/api/style/v1/tag-style/${id}/`
  //       );

  //       if (data.status === 200) {
  //         if (data?.data?.length === 0) {
  //           setError("No SubCategory found");
  //         }
  //         setSubcategory(data?.data || []);
  //       }
  //     } catch (error) {
  //       setError(error?.response?.data?.message || "Failed to load data");
  //     } finally {
  //       setSubCategoryLoading(false);
  //     }
  //   };

  const fetchCategoryImages = async (page) => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiInstance.get(
        `/api/style/v1/tag-style/${id}/?page=${page}`
      );

      if (res.status === 200) {
        setCatagoryImages(res.data.data.results); // assuming you're displaying only the results
        setTotalPages(res.data.data.total_pages); // track total pages for pagination UI
        setTotalItems(res.data.data.count || 0);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    //   fetchSubCategoryData();
    fetchCategoryImages(currentPage);
  }, [id]);

  const handlePageChange = (page) => {
    setCurrentPage(page);

    const params = new URLSearchParams(searchParams);
    params.set("currentPage", page);
    setSearchParams(params);
  };

  const handleCategoryChange = (newPath) => {
    setCurrentPage(1);
    navigate(newPath);
  };

  return (
    <div className="parent_Container">
      <div className="content_wrapper ">
        <Sidebar
          logo="FP ONE"
          mainLoading={loading}
          currentPage={currentPage}
        />

        <div
          style={{ overflowX: "hidden", width: "100%" }}
          className="md:ml-[18rem] mt-[5rem] md:mt-0"
        >
          {categoryLoading ? (
            <p style={{ fontSize: "18px", color: "gray" }}>
              Loading Categories...
            </p>
          ) : (
            <Category
              SubCategory={subCategory}
              subCategoryError={error}
              onCategoryClick={handleCategoryChange}
            />
          )}

          {subCategory.length > 0 && <div className="separator"></div>}
          <Breadcrumb onCategoryClick={handleCategoryChange} isMSR={false} />
          <button onClick={() => navigate(-1)} className="mb-5">
            &larr; Back
          </button>
          {loading ? (
            <div className="loader-container">
              <ClipLoader color="#3498db" loading={loading} size={50} />
            </div>
          ) : categoryImages?.length === 0 ? (
            <div className="no-products loader-container">
              No Products Found
            </div>
          ) : (
            <div className="product_container">
              {categoryImages?.map((product) => (
                <div className="cart" key={product.style_id}>
                  <Link
                    to={`/${id}/product-detail/${product?.style_id}`}
                    className="image_container"
                  >
                    <img
                      src={
                        product?.cover_image ||
                        product?.photos?.[0]?.url ||
                        DummyImage
                      }
                      className="image"
                      alt={product.style_name || "Product"}
                      loading="lazy"
                    />
                  </Link>
                </div>
              ))}
            </div>
          )}

          {categoryImages?.length > 0 && totalPages > 1 && (
            <div className="mt-4">
              <Pagination
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebarstags;
